module.exports = __webpack_public_path__ + "img/hill-alone.d17ecee9.png";